/**
 * @fileoverview Weight tracking route definitions.
 *
 * Lazy-loaded so the @mui/x-charts dependency is only fetched when the weight
 * page is visited.
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { createRoutes } from '../utils/routeHelpers';

const WeightPage = lazy(() => import('../../features/weight/pages/WeightPage'));

export const weightRoutes: RouteObject[] = createRoutes([
  { path: 'weight', Component: WeightPage },
]);
